// Module
var code = `<div ui-tree id="tree-root">
    <ol ui-tree-nodes ng-model="data">
        <li ng-repeat="(node_name, node) in form.roles" ui-tree-node ng-include="'nodes_renderer.html'"></li>
    </ol>
</div>

${"<" + "script"} type="text/ng-template" id="nodes_renderer.html">
    <div ui-tree-handle class="tree-node tree-node-content">
        <button ng-if="model.permissions.indexOf(node.name) >= 0 "
                ng-click="model.permissions.remove(node.name); \$event.preventDefault();"
                class="btn btn-success btn-sm"
                ng-class="{'btn-xs': node.is_action}"
                ng-disabled="node.name == 'admin'"
        >{{node.name}}
        </button>
        <button ng-if="model.permissions.indexOf(node.name) < 0"
                ng-click="model.permissions.push(node.name); \$event.preventDefault();"
                class="btn btn-warning btn-sm"
                ng-class="{'btn-xs': node.is_action}"
                ng-disabled="node.name == 'admin'"
        >{{node.name}}
        </button>
    </div>
    <ol ui-tree-nodes="" ng-model="node.items" ng-class="{hidden: collapsed}">
        <li ng-repeat="(node_name, node) in node.items" ui-tree-node ng-include="'nodes_renderer.html'">
        </li>
    </ol>
${"<" + "/script"}>


`;
// Exports
module.exports = code;